import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { IncidentSubCategoryDto, IncidentCategoryDto } from '@cradua/data';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-incident-sub-category',
  templateUrl: './incident-sub-category.component.html',
  styleUrls: ['./incident-sub-category.component.scss'],
})
export class IncidentSubCategoryComponent implements OnChanges {
  @Input() incidentsubcategorys: IncidentSubCategoryDto[];
  @Input() incidentcategorys: IncidentCategoryDto[];
  incidentsubcategoryForm: FormGroup;
  incidentsubcategoryFormArray: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<IncidentSubCategoryDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  filteredDelete: Array<any> = [];
  filteredIncidentSubCategory: Array<any> = [];
  status: boolean;
  selectedIncidentSubCategoryId: any;
  selectedIndex = null;

  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createIncidentSubCategoryForm();
  }

  createIncidentSubCategoryForm() {
    this.incidentsubcategoryFormArray = this.fb.group({
      IncidentSubCategorys: this.fb.array([]),
    });
    this.incidentsubcategoryForm = this.fb.group({
      IncidentSubCategoryName: ['', Validators.required],
      IncidentCategoryId: this.selectedIncidentSubCategoryId,
      id: null,
    });
  }

  // method to display companies
  setIncidentSubCategory() {
    const control = this.incidentsubcategoryFormArray.controls
      .IncidentSubCategorys as FormArray;
    this.filteredIncidentSubCategory.forEach((e) => {
      control.push(
        this.fb.group({
          IncidentSubCategoryName: e.IncidentSubCategoryName,
          IncidentCategoryId: e.IncidentCategoryId,
          id: e.id,
        })
      );
    });
  }

  // method to add Company
  addIncidentSubCategory(incidentsubcategory: IncidentSubCategoryDto) {
    console.log('incidentsubcategory');
    const control = this.incidentsubcategoryFormArray.controls
      .IncidentSubCategorys as FormArray;
    control.insert(
      0,
      this.fb.group({
        IncidentSubCategoryName: incidentsubcategory.IncidentSubCategoryName,
        IncidentCategoryId: this.selectedIncidentSubCategoryId,
      })
    );
  }

  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.incidentsubcategoryFormArray.controls
      .IncidentSubCategorys as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter incidentsubcategory
  selectIncidentCategory(event: string) {
    this.filteredIncidentSubCategory = this.incidentsubcategorys.filter(
      (s) => s.IncidentCategoryId === event
    );
    this.selectedIncidentSubCategoryId = event;
    const control = this.incidentsubcategoryFormArray.controls
      .IncidentSubCategorys as FormArray;

    if (this.filteredIncidentSubCategory.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setIncidentSubCategory();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  print(event: any) {
    window.print();
  }
  // method to delete company from arrary list
  deleteIncidentSubCategory(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.incidentsubcategoryFormArray.controls
          .IncidentSubCategorys as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.incidentsubcategorys.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.incidentsubcategorys[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: IncidentSubCategoryDto) {
    if (this.incidentsubcategoryForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.incidentsubcategoryFormArray
        .get('IncidentSubCategorys')
        ['controls'][this.selectedIndex].patchValue({
          IncidentSubCategoryName: formValue.IncidentSubCategoryName,
        });
    } else {
      this.addIncidentSubCategory(formValue);
    }
    this.selectedIndex = null;
    this.incidentsubcategoryForm.reset();
  }

  onEdit(index, value: IncidentSubCategoryDto) {
    this.selectedIndex = index;
    this.incidentsubcategoryForm.patchValue({
      IncidentSubCategoryName: value.IncidentSubCategoryName,
    });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.incidentsubcategoryForm.reset();
  }

  onSubmit(formValue: any) {
    formValue.type = 'incidentsubcategory';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length > 0) {
      this.filteredDelete.unshift('incidentsubcategory');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
